module.exports = function(h, row) {
    let length = row.products_count;

    if (length < 1) {
        return <i>No products assigned</i>;
    }

    return <i>Assigned to {length} products</i>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/pricebook/product.jsx